import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IApplyCodeParams,
  IApplyCodeResult,
  TApplyCodeResponse,
} from '../types/DiscountCode.types';
import { DISCOUNT_CODES_PATH } from './campaignApiBase';

/**
 * Apply a code to the current office (the office↔campaign opt-in). The office is
 * resolved from the JWT plus `x-office`, so the body carries only the code.
 *
 * A 201 means a new application was recorded; a 200 means the office already
 * held the code. The body is the same for both, so the status is kept as
 * `created` rather than dropped with the rest of the response.
 *
 * Non-2xx responses carry `{ reason, message }` and are surfaced to the caller
 * as the raw AxiosError — the dialog maps `reason` to its three distinct states.
 */
export const applyCode = async ({ code }: IApplyCodeParams): Promise<IApplyCodeResult> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<TApplyCodeResponse>(
    DISCOUNT_CODES_PATH,
    { code },
    { headers },
  );

  return { appliedCode: response.data, created: response.status === 201 };
};
